import { getChartTheme } from '../themes/customTheme';
import { Component, OnInit, ViewChild, AfterViewInit, Input, OnChanges } from '@angular/core';
import * as echarts from 'echarts/lib/echarts';
import 'echarts/lib/chart/pie';
import 'echarts/lib/chart/line';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/title';
import 'echarts/lib/component/toolbox';
import 'echarts/lib/component/dataZoom';
import { StatsService } from '../../stats.service';
import { createLineChart } from './lineCharts';
import { Line } from './line';
import { TranslateService } from '@ngx-translate/core';
import { getChartSize } from '../chartUtils';
import { tap, first } from 'rxjs/operators';
import * as store from 'store';
import { ThemeDirective } from '../../../../theme/theme.directive';
interface ILineChartComponent {
  url: Function;
  options: any;
  sessionId: any;
  filters: any;
}

@Component({
  selector: 'app-line-chart',
  styleUrls: ['./line.component.css'],
  template: `
    <div class="flexed full-width ibox-content" style="padding: 2%;">
      <div [ngClass]="{ 'hide': !containsData,'full-width':true  }" #chart style="width:100%;height:45vh;" class="full-width"></div>
      <div style="width:100%;height:45vh;" [ngClass]="{ 'hide': containsData,'full-width':true,'chart-no-data':true }">
        <i class="fa fa-line-chart" aria-hidden="true"></i>
        <div>{{'stats.no_data'|translate}}</div>
      </div>
    </div>
  `
})
export class LineChartComponent implements OnInit, AfterViewInit, ILineChartComponent, OnChanges {
  @Input() url: Function;
  @Input() options: any;
  @Input() sessionId: any;
  @Input() filters: any;
  @Input() filter: any;
  containsData = false;
  chartInstance: any;
  @ViewChild('chart') chart;

  constructor(private statsService: StatsService, private translate: TranslateService) {}

  ngOnInit() {}
  ngAfterViewInit() {
    setTimeout(() => {
      const parent = this.chart.nativeElement as HTMLDivElement;
      const parentSize = getChartSize(parent);
      const theme = store.get(ThemeDirective.THEME);
      const chartTheme = getChartTheme(theme);
      this.chartInstance = echarts.init(parent, chartTheme, parentSize);
      this.updateLineChart('hour');
    }, 0);
  }
  ngOnChanges() {
    this.updateLineChart('hour');
  }
  updateLineChart(filter: string) {
    this.chartInstance.showLoading();
    const setOptions$ = tap(data =>
      setTimeout(
        () => this.chartInstance.setOption(createLineChart(data, this.options(data, filter))),
        500
      )
    );
    const setContainsData$ = tap((data: any) => (this.containsData = data.length > 0));
    const hideLoading$ = tap(() => this.chartInstance.hideLoading());
    const source$ = this.statsService.call(`${this.url(this.sessionId, filter)}`);

    source$.pipe(first(), setOptions$, setContainsData$, hideLoading$).subscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/stats/charts/line/line.component.ts